import { defineMessages } from 'react-intl';

export default defineMessages({
  connect: {
    id: 'UsernavVisitor.connect',
    defaultMessage: 'se connecter',
    description: 'titre du lien se connecter du header',
  },
});
